<template>
  <el-dialog
    title="列配置"
    @close="closeDialog"
    :visible.sync="isShow"
    width="800px"
    class="tableDialogClassDS"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
  <div v-loading='loading'>
    <div class="configInfo y-f y-f-wrap">
      <div class="y-f y-f-jc mb24 min-width155"  v-for="(item, index) in tableList" :key="index" :class="{'border-right': (index +1)%6 != 0}">
        <div class="fit-content" v-if="item">
          <div class="y-f y-f-a y-pl-12 y-pr-12 y-f-jc" @click.stop="setCheckedColumn(item, index)">
            <i v-show="item.isChecked" class="icomoon-checkbox-checked y-fs-14 y-fc-4C84FF y-mr-5" :class="{'y-fc-CCDAFC': item.isCancelSelected===0}" ></i>
            <i v-show="!item.isChecked" class="icomoon-checkbox-unchecked y-fs-14 y-fc-A2A5AC y-mr-5"></i>
            <span class="y-c-p y-p-r">
              <span>{{item.cnName}}</span>
            </span>
          </div>
          <div class="y-d-ib y-f y-f-jb y-m-auto y-mt-5 y-w-99">
            <span class="y-d-ib" @click.stop="preventFn(item, index)">
              <img v-if="index==0" src="@/assets/images/dianshang/left-gray.png" class="icon-move"/>
              <img v-else src="@/assets/images/dianshang/left-blue.png" class="y-c-p icon-move"/>
            </span>
            <span class="y-d-ib" @click.stop="nextFn(item, index)">
              <img v-if="index == (tableList.length - 1)" src="@/assets/images/dianshang/right-gray.png" class="icon-move"/>
              <img v-else src="@/assets/images/dianshang/right-blue.png" class="y-c-p icon-move"/>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="tableConfigFooter y-f y-f-jc">
      <el-button class="y-w-120 border-btn" @click="toReset">恢复系统默认</el-button>
      <el-button class="y-w-100" @click="isShow = false">取 消</el-button>
      <el-button class="y-w-100" type="primary" @click="addUserColumnConfig">确认</el-button>
    </div>
  </div>
  </el-dialog>
</template>

<script>
import { insertUserColumnSettingApi, resetUserColumnSettingApi } from '../../../../api/columnSetting';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // curComponent: {
    //   type: String
    // },
    data: {
      type: Array
    },
    activeName: {
      type: String,
      default:'summary'
    }
    // mallCode: {
    //   type: String
    // }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      isShow: this.value,
      tableList: [],
      loading: false
    };
  },
  mounted() {
    this.tableList = JSON.parse(JSON.stringify(this.data));
    this.tableList.forEach((o,index) => {
      if(o){
        this.$set(o, 'isChecked', o.isSelected && o.isSelected === 1);
      }
    });
  },
  methods: {
    nextFn(item, index) {
      // 最后一列不能再往后移了
      if (index == (this.tableList.length - 1)) {
        return false;
      }
      let list = [];
      this.tableList.forEach((o, i) => {
        if ( i == index) {
          list.push(this.tableList[index + 1]);
        } else if ( i == index + 1){
          list.push(item);
        } else {
          list.push(o);
        }
      });
      this.tableList = JSON.parse(JSON.stringify(list));
    },
    preventFn(item, index) {
      // 第一列不能再往前移动了
      if (index == 0) {
        return false;
      }
      let list = [];
      this.tableList.forEach((o, i) => {
        if ( i == index - 1) {
          list.push(item);
        } else if ( i == index){
          list.push(this.tableList[index - 1]);
        } else {
          list.push(o);
        }
      });
      this.tableList = JSON.parse(JSON.stringify(list));
    },
    setCheckedColumn(item, index) {
      if(item.isCancelSelected===0) return;
      this.tableList[index].isChecked = !this.tableList[index].isChecked;
    },
    addUserColumnConfig() {
      let updateList = this.tableList.map((r, i) => ({
          id: r.id, // 对应列配置查询接口返回的id
          tabCode: r.tabCode, // 汇总101，明细102
          isSelected: r.isChecked ? 1 : 0, // 是否选中，1：勾选，0：未勾选
          sort: i+1, // 列配置指定顺序
          userId: this.userMess.loginId
        })
      );
      this.loading = true;
      insertUserColumnSettingApi(updateList)
        .then(res => {
          if (res.message === 'ok') {
            this.loading = false;
            this.$message.success(res.data || res.message || '添加成功');
            this.closeDialog();
          } else {
            this.loading = false;
            this.$message.error(res.data || res.message || '添加失败');
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error('添加失败');
        });
    },
    toReset() {
      let params = {
        tabCode: ( this.activeName == 'summary' ) ? 101 : 102, // 汇总101，明细102
        userId: this.userMess.loginId
      };
      this.loading = true;
      resetUserColumnSettingApi(params).then(res => {
        if (res.message === 'ok') {
          this.loading = false;
          this.$message.success(res.data || res.message || '恢复系统默认设置成功');
          this.closeDialog();
        } else {
          this.loading = false;
          this.$message.error(res.data || res.message || '恢复系统默认设置失败');
        }
      })
      .catch(() => {
        this.loading = false;
        this.$message.error('恢复系统默认设置失败');
      });
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close');
    }
  }
};
</script>
<style>
.min-width155{
  min-width: 155px;
}
</style>

